import { FC, ReactElement } from 'react';

import { RaaExpandablePreview } from 'raa-react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';

const BebyggelseFastigheterSection: FC<{ fastigheter: string[] }> = ({ fastigheter }): ReactElement => {
  return (
    <DrawerSection>
      <h2 className="tw-heading-md tw-mb-3">Berörda fastigheter</h2>
      {fastigheter.length > 0 && (
        <RaaExpandablePreview height={80} ariaLabel="Lista med berörda fastigheter">
          <ul className="tw-mt-2">
            {fastigheter.map((fastighet) => (
              <li key={fastighet}>{fastighet}</li>
            ))}
          </ul>
        </RaaExpandablePreview>
      )}
    </DrawerSection>
  );
};

export default BebyggelseFastigheterSection;
